import { createContext } from "react";

export interface RHImageContextInterface {
  loading: "eager" | "lazy";
}

export const RHImageContext = createContext<RHImageContextInterface>({
  loading: "lazy"
});
